import { COMMENTS } from './Base';

export const onCreateCommentRequest = (payload = [], cb) => ({ payload, cb, type: COMMENTS.CREATE_REQUEST });
export const onCreateCommentFailure = (errors = {}) => ({ errors, type: COMMENTS.CREATE_FAILURE });
export const onCreateCommentSuccess = (payload = {}) => ({ payload, type: COMMENTS.CREATE_SUCCESS });

export const onDeleteCommentRequest = (payload = [], cb) => ({ payload, cb, type: COMMENTS.DELETE_REQUEST });
export const onDeleteCommentFailure = (errors = {}) => ({ errors, type: COMMENTS.DELETE_FAILURE });
export const onDeleteCommentSuccess = (payload = {}) => ({ payload, type: COMMENTS.DELETE_SUCCESS });

export const onGetCommentsRequest = (payload = [], cb) => ({ payload, cb, type: COMMENTS.GET_REQUEST });
export const onGetCommentsFailure = (errors = {}) => ({ errors, type: COMMENTS.GET_FAILURE });
export const onGetCommentsSuccess = (payload = {}) => ({ payload, type: COMMENTS.GET_SUCCESS });
